import { render, staticRenderFns } from "./frozenGoodsDeclaration.vue?vue&type=template&id=8352a554&scoped=true&"
import script from "./frozenGoodsDeclaration.vue?vue&type=script&lang=js&"
export * from "./frozenGoodsDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./frozenGoodsDeclaration.vue?vue&type=style&index=0&id=8352a554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8352a554",
  null
  
)

export default component.exports